"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegenerativeBattleCryAbilityHandler = exports.RegenerativeBattleCryActorAbilityFactory = exports.RegenerativeBattleCryAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class RegenerativeBattleCryAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.RegenerativeBattleCry;
        this.__typeName = "RegenerativeBattleCry";
    }
}
exports.RegenerativeBattleCryAbilityArgs = RegenerativeBattleCryAbilityArgs;
let RegenerativeBattleCryActorAbilityFactory = class RegenerativeBattleCryActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("RegenerativeBattleCry", "AllAllies", 4);
    }
};
RegenerativeBattleCryActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("RegenerativeBattleCry")
], RegenerativeBattleCryActorAbilityFactory);
exports.RegenerativeBattleCryActorAbilityFactory = RegenerativeBattleCryActorAbilityFactory;
let RegenerativeBattleCryAbilityHandler = class RegenerativeBattleCryAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                const afterBannerSequence = sequence.pushSequence("sequential")
                    .push(new core_1.InstantVfxStepArgs(LocationSelector_1.ScreenLocationSelector.Center(), "FallingBannerPurple"))
                    .pushSequence("parallel");
                for (const allyId of container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)) {
                    container.applyBuff({
                        creatorId: ability.invokerId,
                        targetId: allyId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new __1.LinkedEffectsEffectArgs([
                            new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Health, container.getPercentOfBaseAttributeScore(allyId, 10, "Health")),
                            new __1.RegenerationEffectArgs("RegenerativeBattleCry", container.getPercentOfBaseHealth(allyId, 5)),
                        ], false),
                        sequence: afterBannerSequence.pushSequence("sequential"),
                        onApplied: (sequence) => {
                            sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "chest"), "GreenEnergyCircle"));
                        }
                    });
                }
            }
        });
    }
};
RegenerativeBattleCryAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.RegenerativeBattleCry)
], RegenerativeBattleCryAbilityHandler);
exports.RegenerativeBattleCryAbilityHandler = RegenerativeBattleCryAbilityHandler;
